"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formatName = _interopRequireDefault(require("../utils/formatName"));

var _formatFriendlyName = _interopRequireDefault(require("../utils/formatFriendlyName"));

var _TitleTypes = _interopRequireDefault(require("../constants/TitleTypes"));

var _default = _react.default.createClass({
  displayName: "FormattedName",
  propTypes: {
    email: _react.PropTypes.string,
    familyName: _react.PropTypes.string,
    givenName: _react.PropTypes.string,
    isFriendly: _react.PropTypes.bool,
    name: _react.PropTypes.string,
    options: _react.PropTypes.object,
    titleType: _react.PropTypes.oneOf(Object.keys(_TitleTypes.default).map(function (title) {
      return _TitleTypes.default[title];
    }))
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isFriendly: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        email = _this$props.email,
        familyName = _this$props.familyName,
        givenName = _this$props.givenName,
        isFriendly = _this$props.isFriendly,
        name = _this$props.name,
        options = _this$props.options,
        titleType = _this$props.titleType;
    var formattedName = isFriendly ? (0, _formatFriendlyName.default)({
      givenName: givenName,
      familyName: familyName,
      email: email
    }, options) : (0, _formatName.default)({
      firstName: givenName,
      lastName: familyName,
      email: email,
      name: name,
      titleType: titleType
    }, options);
    return _react.default.createElement("span", null, formattedName);
  }
});

exports.default = _default;
module.exports = exports.default;